<template>
  <div
    class="d-flex flex-column main-wrapper"
    style="
      height: 100vh;
      overflow-y: scroll;
      background: #12102e;
    "
  >

    <div style="height: 233px; background-color: #2b1c59; padding: 53px 21px 26px">
      <div class="">
        <div class="flex items-center justify-center gap-8">
          <!-- Profile Image -->
          <img
            src="/logo.png"
            alt="Profile"
            class="w-20 h-20 rounded-full scale-[1.6] object-cover border-2 border-[#ffb800]"
          />

          <!-- User Info -->
          <div class="space-y-2">
            <h1 class="text-[28px] font-semibold text-white leading-none">
              Name: {{ $store.state.authUser.name }}
            </h1>

            <p class="text-[16px] text-gray-400">
              ဖုန်းနံပါတ်:
              <span class="text-gray-300">
                {{ blurLastFiveCharacters($store.state.authUser.phone) }}
              </span>
            </p>

            <div class="flex items-center gap-6 mt-1">
              <p class="text-[16px] text-gray-400">
                {{ $t("setting.balance") }}:
                <b class="text-[#ffb800]">{{
                  Number($store.state.amount).toLocaleString()
                }}</b>
                <span class="text-gray-300">฿</span>
              </p>

              <p class="text-[16px] text-gray-400">
                {{ $t("setting.withdraw") }}:
                <b class="text-[#ffb800]">{{
                  Number($store.state.totalWithdraw).toLocaleString()
                }}</b>
                <span class="text-gray-300">฿</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 side-nav-bar-custom my-2 !px-7">
      <nav
        class="side-nav"
        style="background: #2b1c59; border-radius: 15px"
      >
        <div>
          <div>
            <!-- Nav items -->
            <ul class="navbar-nav-custom">
              <li
                class="border-b-[1px] px-[10px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                @click="$router.push('/history')"
              >
                <div class="!flex items-center">
                  <img
                    src="https://www.burma368.net/static/image/account/myWallet.png"
                    style="width: 30px; height: 30px; margin-right: 1rem"
                    alt=""
                  />
                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >{{ $t("setting.transaction") }}
                  </span>
                </div>
                <div style="color: #fff">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </li>
              <li
                class="border-b-[1px] px-[10px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                @click="$router.push('/deposit')"
              >
                <div class="!flex items-center gap-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="url(#grad)"
                  >
                    <defs>
                      <linearGradient
                        id="grad"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="24"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop
                          offset="0%"
                          stop-color="#FFD84D"
                        />
                        <stop
                          offset="100%"
                          stop-color="#FF9900"
                        />
                      </linearGradient>
                    </defs>
                    <path
                      d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3H3V7z"
                      stroke="#FFC107"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <rect
                      x="3"
                      y="10"
                      width="18"
                      height="11"
                      rx="2"
                      stroke="#FFC107"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M12 14v4m0 0 2-2m-2 2-2-2"
                      stroke="url(#grad)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >
                    {{ $t("setting.deposit") }}
                  </span>
                </div>
                <div style="color: #fff">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </li>
              <li
                class="border-b-[1px] px-[10px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                @click="$router.push('/withdraw')"
              >
                <div class="!flex items-center gap-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="url(#grad)"
                  >
                    <defs>
                      <linearGradient
                        id="grad"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="24"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop
                          offset="0%"
                          stop-color="#FFD84D"
                        />
                        <stop
                          offset="100%"
                          stop-color="#FF9900"
                        />
                      </linearGradient>
                    </defs>
                    <path
                      d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3H3V7z"
                      stroke="#FFC107"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <rect
                      x="3"
                      y="10"
                      width="18"
                      height="11"
                      rx="2"
                      stroke="#FFC107"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M12 18v-4m0 0-2 2m2-2 2 2"
                      stroke="url(#grad)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >
                    {{ $t("setting.withdraw") }}
                  </span>
                </div>
                <div style="color: #fff">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </li>
              <li
                class="border-b-[1px] px-[10px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                @click="$router.push('/promotion')"
              >
                <div class="!flex items-center">
                  <img
                    src="https://www.burma368.net/static/image/account/mypromotion.png"
                    style="width: 30px; height: 30px; margin-right: 1rem"
                    alt=""
                  />
                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >
                    {{ $t("footer.promotion") }}
                  </span>
                </div>
                <div style="color: #fff">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </li>
              <li
                class="px-[10px] border-b-[1px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                @click="() => $router.push('/banking')"
              >
                <div class="!flex items-center">
                  <img
                    src="https://www.burma368.net/static/image/account/mybankcard.png"
                    style="width: 30; height: 30; margin-right: 1rem"
                    alt=""
                  />
                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >{{ $t("setting.bank_account") }}</span>
                </div>
                <div>
                  <i
                    style="color: #fff"
                    class="fas fa-chevron-right"
                  ></i>
                </div>
              </li>
              <li
                class="px-[10px] border-b-[1px] py-3 !flex items-center cursor-pointer justify-between"
                style="border-bottom-color: rgba(159, 160, 191, 0.6)"
                data-toggle="modal"
                data-target="#editUserPassword"
              >
                <div class="!flex items-center">
                  <!-- <i class="fas fa-key mr-3" style="color: white; font-weight: 500;"></i> -->
                  <img
                    src="https://www.burma368.net/static/image/account/resetpassword.png"
                    style="width: 30px; height: 30px; margin-right: 1rem"
                    alt=""
                  />
                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >{{ $t("setting.update_password") }}</span>
                </div>
                <div>
                  <i
                    style="color: #fff"
                    class="fas fa-chevron-right"
                  ></i>
                </div>
              </li>
              <li
                @click="openModal = true"
                class="px-[10px] py-3 !flex items-center cursor-pointer justify-between"
              >
                <div class="!flex items-center">
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-language.png"
                    style="width: 30px; height: 30px; margin-right: 1rem"
                    alt=""
                  />
                  <span
                    class="text-[20px] leading-[1.3]"
                    style="color: hsla(0, 0%, 100%, 0.6)"
                  >{{ $t("setting.update_language") }}</span>
                </div>
                <div style="color: #fff">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <ul
        class="py-4 !px-[20px]"
        style="background: #2b1c59; border-radius: 15px; margin-top: 50px"
      >
        <li class="">
          <div
            class="flex cursor-pointer items-center gap-2"
            @click="logoutModalOpen = true"
          >
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-logout.png"
              style="width: 30px; height: 30px; margin-right: 1rem"
              alt=""
            />
            <span
              class="text-[20px] leading-[1.3]"
              style="color: hsla(0, 0%, 100%, 0.6)"
            >{{ $t("setting.logout") }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="openModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    >
      <div
        class="bg-[#1F1444] rounded-2xl w-[90%] p-6 text-white shadow-xl transform animate-[fadeIn_0.3s_ease-out_forwards]"
      >
        <div class="space-y-3">
          <div
            v-for="lang in languages"
            :key="lang.code"
            class="flex items-center justify-between bg-[#2C255C] p-3 rounded-lg cursor-pointer hover:bg-[#3A3370]"
            @click="
              () => {
                setLangLocalstorage(lang.code);
                selectedLang = lang.code;
              }
            "
          >
            <div class="flex items-center gap-3">
              <img
                :src="lang.flag"
                alt=""
                class="w-6 h-6"
              />
              <span>{{ lang.name }}</span>
            </div>
            <div>
              <div
                class="w-5 h-5 rounded-full border-2"
                :class="selectedLang === lang.code
                  ? 'border-purple-400 bg-purple-500'
                  : 'border-gray-400'
                  "
              ></div>
            </div>
          </div>
        </div>

        <div class="flex justify-between mt-6">
          <button
            class="px-4 py-2 border border-purple-400 text-purple-400 rounded-lg"
            @click="openModal = false"
          >
            မထွက်တော့ပါ
          </button>
          <button
            class="px-4 py-2 bg-purple-500 rounded-lg"
            @click="openModal = false"
          >
            အတည်ပြုမည်
          </button>
        </div>
      </div>
    </div>
    <!-- </transition> -->

    <div
      v-if="logoutModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    >
      <div
        class="rounded-2xl border-[8px] relative modal-background w-[90%] border-[] rounded-[26px] w-[80%] p-6 text-white shadow-xl transform animate-[fadeIn_0.3s_ease-out_forwards]"
        style=""
      >
        <img
          src="https://www.burma368.net/static/image/common/popup-icon.png"
          alt=""
          class="w-[160px] h-[84px] absolute top-[-80px] left-[50%] translate-x-[-50%]"
        />
        <p class="text-center !text-[22px] !font-semibold">
          {{ $store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?", }}
        </p>
        <div class="flex justify-between mt-6 gap-2">
          <button
            class="px-4 py-3 border border-purple-400 w-full text-purple-400 !rounded-full"
            @click="logoutModalOpen = false"
          >
            {{ $store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ" }}
          </button>
          <button
            class="px-4 py-3 bg-purple-500 w-full !rounded-full"
            @click="logout()"
          >
            {{ $store.state.language === "en" ? "Sure" : "သေချာပြီ" }}
          </button>
        </div>
      </div>
    </div>

    <!-- ==== modal for user password edit ==== -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal- modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content !bg-[#1F1444]">
          <div class="modal-body !bg-[#1F1444] px-0 pb-0">
            <div class="card border-0 mb-0 !bg-[#1F1444]">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="form-group text-white">
                  {{ $t("setting.old_password") }}
                  <div class="mt-2 input-group">
                    <input
                      class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                      v-model="password.old"
                    />
                  </div>
                  <span class="text-danger">{{ errors.old }}</span>
                </div>
                <div class="form-group text-white">
                  {{ $t("setting.new_password") }}
                  <div class="mt-2 input-group">
                    <input
                      class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                      v-model="password.new"
                    />
                  </div>
                  <span class="text-red-500 text-xs mt-1">{{
                    errors.new
                  }}</span>
                </div>
                <div class="form-group text-white">
                  {{ $t("setting.confirm_password") }}
                  <div class="mt-2 input-group">
                    <input
                      class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                      v-model="password.confirm"
                    />
                  </div>
                  <span class="text-red-500 text-xs mt-1">{{
                    errors.confirm || errors.confirmPassword
                  }}</span>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="bg-gradient-to-l text-white !text-[20px] from-[#924aff] to-[#4f3ffd] w-full !rounded-full py-3"
                    @click="changeNewPassword"
                  >
                    <div v-if="!isConfirm">
                      {{ $t("setting.update") }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isConfirm"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
      selectedLang: localStorage.getItem("language") || "en",

      isCollecting: false,
      openModal: false,
      logoutModalOpen: false,
      languages: [
        {
          code: "en",
          name: "English",
          flag: "https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png",
        },
        {
          code: "cn",
          name: this.$t("cn"),
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png",
        },
        {
          code: "mm",
          name: "မြန်မာ",
          flag: "https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png",
        },
        {
          code: "th",
          name: "ภาษาไทย",
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png",
        },
      ],
    };
  },
  methods: {
    async collectAmount() {
      try {
        this.isCollecting = true;
        await axios.get("/claim-loss-return", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.fetchUser();
        Toast.success(
          this.$store.state.language === "en" ? "Success!" : "Success!"
        );
        this.isCollecting = false;
      } catch (error) {
        this.isCollecting = false;
        Toast.fail(this.$store.state.language === "en" ? "Fail!" : "Fail!");
      }
    },
    ...mapActions(["logoutUser", "fetchUser"]),
    blurLastFiveCharacters(inputString = "0000000000") {
      // Get the length of the input string
      const length = inputString.length;

      // Check if the input string has at least five characters
      if (length >= 7) {
        // Extract the first part of the string
        const firstPart = inputString.substring(length - 5, length);

        // Create a string with '*' characters for the last five numbers
        const blurredCharacters = "*".repeat(length - 5);

        // Concatenate the first part and the blurred numbers
        const blurredString = blurredCharacters + firstPart;

        return blurredString;
      } else {
        // Return the input string unchanged if it has less than five characters
        return inputString;
      }
    },
    setLangLocalstorage(language) {
      localStorage.setItem("language", language);
      this.$store.commit("setLanguage", language);
      this.$i18n.locale = language;
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === "en"
            ? "Old password required"
            : "လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။";
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === "en"
            ? "New password required"
            : "လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။";
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === "en"
            ? "Confirm password required"
            : "အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။";
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === "en"
            ? "New passwords not match"
            : "လျှို့ဝှက်နံပါတ် မတူညီပါ။";
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure?"
            : "သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မလုပ်တော့ပါ။",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ။",
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => { });
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        const res = await axios.post(
          "/auth/userPasswordChange",
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.password = {};
        this.errors = {};
        $("#editUserPassword").modal("hide");
      } catch (error) {
        Toast.fail(
          this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။"
        );
      }
    },
    async logout() {
      await this.logoutUser();
      if (this.$route.path === "/home") {
        // this.$router.go();
      } else {
        this.$router.push("/home");
        // this.$router.go();
      }
      Toast.success(
        this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
      );
      this.logoutModalOpen = false;
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    // if(authUser && !authUser.is_verified) {
    //   this.$router.push('/auth/verify');
    // }
  },
};
</script>
<style scoped>
.main-btn {
  background: #000000 !important;
  color: white !important;

  border-radius: 20px;
  height: 30px;
  min-width: 6rem;
  border: 0;
  padding: 0 1rem;
  font-size: 0.8rem;
  text-align: center;
  box-shadow: none;

  &:hover {
    color: #fff;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0 !important;
    transform: scale(0.95);
  }

  to {
    opacity: 1 !important;
    transform: scale(1);
  }
}

.collect-section {
  position: relative;
  background: #21293d;
  border-radius: 7px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: url('../../assets/stars.png'); */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.3;
    pointer-events: none;
  }

  .amount {
    font-size: 1.3rem;
    font-weight: bolder;
    line-height: normal;
  }
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  /* background: #ff000014; */
  font-weight: bold;
}

.account-container-wrapper {
  width: auto;
  height: 200px;
  /* border-radius: 5px; */
  color: black !important;
  /* background: #552A07; */
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
  /* background: #282A31;  */
  background: #21293d;
  border-radius: 7px;

  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */
  /* backdrop-filter: blur(10px);-webkit-backdrop-filter: blur(0.5px) !important; */
}
</style>
